import React, { useMemo } from "react";

export default function ReservedCard({
  resv,                 // { no, slotId, at, reservedType, by }
  waitCount,            // number | null
  myAheadCount,         // number | null 
  displayName,          // string | undefined
  onCancel,             // () => void
  cancelBusy = false,   // boolean
  showLinks = false,    // 画面下の「マイ予約／一覧」リンクを出す場合
  LinksArea = null,     // カスタムリンクを差し込みたいとき（JSX）
}) {
  const reservedAtText = useMemo(() => {
    if (!resv?.at) return "—";
    const d = new Date(resv.at);
    const pad = (n) => `${n}`.padStart(2, "0");
    const w = "日月火水木金土"[d.getDay()];
    return `${d.getFullYear()}/${pad(d.getMonth() + 1)}/${pad(d.getDate())}(${w}) ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }, [resv]);

  return (
    <div className="line-card">
      <div className="line-wait-no" style={{ marginBottom: 12 }}>
        <div className="line-wait-caption-reserved">あなたの受付番号</div>
        <div className="line-number-value">{resv?.no ?? "—"}</div>
        <div className="line-muted-reserved">{reservedAtText}</div>
      </div>

      <p className="line-desc" style={{ marginTop: 4 }}>
        ご予約ありがとうございます。<b>来院時にこの受付番号をスタッフまでご提示</b>ください。この受付番号は中待合に入るまでの順番です。お呼びする順番は前後する場合があります。
      </p>

      <button className="line-danger-btn" onClick={onCancel} disabled={cancelBusy}>
        {cancelBusy ? "取消しています…" : "予約を取消する"}
      </button>

      {showLinks && LinksArea}

      {displayName && <div className="line-welcome" style={{ marginTop: 12 }}>ようこそ、{displayName} さん</div>}

      <div className="line-wait" style={{ marginTop: 6, marginBottom: 14 }}>
        <div className="line-wait-caption">あなたの順番まであと</div>
        <div className="line-wait-count">
          {Number.isFinite(myAheadCount) ? `${myAheadCount}人` : "—"}
        </div>
      </div>
    </div>
  );
}
